module.exports = __webpack_public_path__ + "static/media/ue.8c35dd3b.svg";